export const enum MaxFlatUnitPriceEnum {
  None,
  NoMax = 0,
  UpTo1Million = 1,
  UpTo2Million = 2,
  UpTo3Million = 3,
}
